import { render, staticRenderFns } from "./BaseTableSimple.vue?vue&type=template&id=13a1c386&scoped=true&"
import script from "./BaseTableSimple.vue?vue&type=script&lang=js&"
export * from "./BaseTableSimple.vue?vue&type=script&lang=js&"
import style0 from "./BaseTableSimple.vue?vue&type=style&index=0&id=13a1c386&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a1c386",
  null
  
)

export default component.exports